// @flow

// Polyfills
import 'regenerator-runtime/runtime';
import 'element-closest';

// Vendors
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// Layouts
import { LayoutBase } from './layouts';

// Layouts
import { GlobalModals } from './components';

// Store
import configureStore from './store';
import './i18n';

// Styles

import 'texkit/dist/styles/texkit.scss';

const { persistor, store } = configureStore();

const MGMW = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <LayoutBase />
      <GlobalModals />
    </PersistGate>
  </Provider>
);

const rootElement = document.getElementById('app-root');
if (rootElement) render(<MGMW />, rootElement);

export default MGMW;
